import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import CommonBanner from "../component/Common/CommonBanner";
import { supabase, isSupabaseConfigured } from "../lib/supabaseClient";
import { formatEventWhen } from "../hooks/useDbEvents";

const EventDbDetail = () => {
  const { eventId } = useParams();
  const [ev, setEv] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (!isSupabaseConfigured || !supabase || !eventId) return;
    let cancelled = false;
    (async () => {
      const { data, error } = await supabase
        .from("events")
        .select("*")
        .eq("id", eventId)
        .maybeSingle();
      if (cancelled) return;
      if (error) setErr(error.message);
      else if (!data) setErr("Event not found or you do not have access.");
      else setEv(data);
    })();
    return () => {
      cancelled = true;
    };
  }, [eventId]);

  if (!isSupabaseConfigured) {
    return (
      <>
        <CommonBanner heading="Event" pagination="Events" />
        <section className="section_padding">
          <div className="container">
            <p>Configure Supabase to view events.</p>
          </div>
        </section>
      </>
    );
  }

  if (err || !ev) {
    return (
      <>
        <CommonBanner heading="Event" pagination="Events" />
        <section className="section_padding">
          <div className="container">
            <p className="text-muted">{err || "Loading…"}</p>
            <Link to="/event">Back to events</Link>
          </div>
        </section>
      </>
    );
  }

  return (
    <>
      <CommonBanner heading={ev.title} pagination="Events" />
      <section className="section_padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <p className="text-muted small">
                {formatEventWhen(ev.starts_at, ev.ends_at)}
                {ev.location ? ` · ${ev.location}` : ""} ·{" "}
                <span className="badge bg-light text-dark border">{ev.visibility}</span>
              </p>
              {ev.image_url && (
                <img
                  src={ev.image_url}
                  alt=""
                  className="img-fluid rounded mb-3"
                  style={{ maxHeight: 400, objectFit: "cover" }}
                />
              )}
              {ev.summary && <p className="lead">{ev.summary}</p>}
              {ev.body && (
                <div className="small" style={{ whiteSpace: "pre-wrap" }}>
                  {ev.body}
                </div>
              )}
              <p className="mt-4 mb-0">
                <Link to="/event">&larr; All events</Link>
                {" · "}
                <Link to="/member/dashboard">My dashboard</Link>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EventDbDetail;
